import { render } from "./NavButton.vue?vue&type=template&id=05456316&scoped=true"
const script = {}

import "./NavButton.vue?vue&type=style&index=0&id=05456316&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05456316"]])

export default __exports__